// src/pages/base/Base.constants.js

import { DollarSign, Package, AlertCircle, Zap } from 'lucide-react';

// Healing configuration
export const HEAL_CONFIG = {
  COST: {
    supplies: 10,
    funds: 500
  },
  AMOUNT: 25
};

// Day advancement timer (in seconds)
export const DAY_TIMER_DURATION = 60;

// Progress increment per second (100 / 60 seconds)
export const DAY_PROGRESS_INCREMENT = 100 / DAY_TIMER_DURATION;

// Tab definitions - can be themed
export const getTabDefinitions = (config) => [
  { id: 'base', label: config.tabs?.base || 'BASE' },
  { id: 'squad', label: config.tabs?.squad || 'SQUAD' },
  { id: 'medbay', label: config.tabs?.medbay || 'MEDBAY' },
  { id: 'research', label: config.tabs?.research || 'RESEARCH' },
  { id: 'missions', label: config.tabs?.missions || 'MISSIONS' }
];

// Resource display configuration - NOW THEME-AWARE
export const getResourceItems = (config) => [
  { 
    icon: DollarSign, 
    label: config.resources?.funds?.toUpperCase() || 'FUNDS',
    getValue: (resources) => {
      // Check if we should use custom formatting (e.g., "SCRAP" instead of "$")
      if (config.resources?.funds && config.resources.funds !== 'funds') {
        return resources.funds.toLocaleString();
      }
      return `$${resources.funds.toLocaleString()}`;
    },
    color: 'text-green-400' 
  },
  { 
    icon: Package, 
    label: config.resources?.supplies?.toUpperCase() || 'SUPPLIES',
    getValue: (resources) => resources.supplies, 
    color: 'text-yellow-400' 
  },
  { 
    icon: AlertCircle, 
    label: config.resources?.intel?.toUpperCase() || 'INTEL',
    getValue: (resources) => resources.intel, 
    color: 'text-blue-400' 
  },
  { 
    icon: Zap, 
    label: config.resources?.power?.toUpperCase() || 'POWER',
    getValue: (resources) => {
      // If resources have powerUsed and powerCapacity, show that instead
      if (resources.powerUsed !== undefined && resources.powerCapacity !== undefined) {
        const percentage = resources.powerCapacity > 0 
          ? Math.round((resources.powerUsed / resources.powerCapacity) * 100)
          : 0;
        return `${resources.powerUsed}/${resources.powerCapacity} (${percentage}%)`;
      }
      return `${resources.power}%`;
    },
    color: 'text-purple-400' 
  }
];

// Initial resource state
export const INITIAL_RESOURCES = {
  funds: 25000,
  supplies: 150,
  intel: 45,
  power: 85
};

// Background image path generator
export const getDeepBackgroundImage = (theme) => `/images/base_deep_background_${theme}.png`;